import { NotificationTemplatesModels } from '@models/notification-templates.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const NotificationTemplatesActions = createActionGroup({
  source: 'NOTIFICATION TEMPLATES',
  events: {
    'Reset To Initial State': emptyProps(),
    'Load History': emptyProps(),
    'Load History Success': props<{
      history: NotificationTemplatesModels.SentNotificationHistoryRow[];
    }>(),
    'Load History Fail': props<{ error: string | null }>(),
    'Load Templates': emptyProps(),
    'Load Templates Success': props<{
      templates: NotificationTemplatesModels.NotificationTemplateCatalogItem[];
    }>(),
    'Load Templates Fail': props<{ error: string | null }>(),
    'Load Template Preview': props<{
      payload: NotificationTemplatesModels.TemplatePreviewRequest;
    }>(),
    'Load Template Preview Success': props<{
      preview: NotificationTemplatesModels.TemplatePreviewResponse;
    }>(),
    'Load Template Preview Fail': props<{ error: string | null }>(),
    'Clear Template Preview': emptyProps(),
    'Send Notification': props<{
      templateSlug: string;
      templateData: Record<string, unknown>;
      recipients: NotificationTemplatesModels.RecipientSelection[];
      groupIds: string[];
    }>(),
    'Send Notification Success': props<{
      row: NotificationTemplatesModels.SentNotificationHistoryRow;
    }>(),
    'Send Notification Fail': props<{ error: string | null }>(),
  },
});
